import { render } from "./RepairRequestForm.vue?vue&type=template&id=438b6045&ts=true"
import script from "./RepairRequestForm.vue?vue&type=script&lang=ts"
export * from "./RepairRequestForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__